import Swiper from 'swiper';
// core version + navigation, pagination modules:
import SwiperCore, { Navigation, Pagination } from 'swiper/core';
// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination]);

export default () => {
    const results = document.querySelector('#results-slider__sidebar .swiper-wrapper');

    if( results ) {
        const resultsAmount = results.dataset.totalResults;

        // results slider
        const resultsSwiper = new Swiper('.grid-results', {
            navigation: {
                nextEl: '.arrow-next',
                prevEl: '.arrow-prev',
            },
            autoHeight: true,
            a11y: true,
            keyboardControl: true,
            grabCursor: true,
            slidesPerView: 1,
            watchOverflow: true,
            loop: resultsAmount > 1,
        });

    }
    
};